import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { LangService } from './lang.service';
import { LangActions } from './lang.actions';

@Injectable()
export class LangEffects {
  private readonly langService = inject(LangService);
  private readonly actions$ = inject(Actions);

  getLangs$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LangActions.loadLangs),
      switchMap((action) => {
        const regLocale = action.payload['locale'];
        return this.langService.loadLangs(action.payload).pipe(
          map((langs) => LangActions.loadLangsSuccess({ langs, reg_locale: regLocale })),
          catchError(({ error }) => of(LangActions.loadLangsFailure(error))),
        );
      }),
    ),
  );
}
